var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c(
            "DIV",
            [
              _c(
                "ItpForm",
                {
                  attrs: {
                    id: _vm.formId,
                    name: _vm.formName,
                    readonly: _vm.item.locked,
                    labelAlign: _vm.$config.forms.defaultLabelAlign,
                    autofocus: "first"
                  },
                  on: {
                    submit: function($event) {
                      return _vm.evh_8564662037462133_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpRow",
                    [
                      _c(
                        "ItpCol",
                        { attrs: { w: "12" } },
                        [
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "5",
                                name: "name",
                                label: _vm._f("pgettext")("Name", "Register"),
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: {
                                  name: "name",
                                  required: "",
                                  placeholder: _vm._f("pgettext")(
                                    "The name of the register.",
                                    "Register"
                                  ),
                                  autofocus: ""
                                },
                                model: {
                                  value: _vm.editor.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "name", $$v)
                                  },
                                  expression: "editor.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "5",
                                name: "company",
                                label: _vm._f("pgettext")(
                                  "Company",
                                  "Register"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormSelect2", {
                                attrs: {
                                  name: "company",
                                  dataSource: _vm.b_6126985650642047_dataSource,
                                  prefetch: "",
                                  "bind-object": "",
                                  textField: "name",
                                  required: ""
                                },
                                model: {
                                  value: _vm.editor.company,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "company", $$v)
                                  },
                                  expression: "editor.company"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "5",
                                name: "notes",
                                label: _vm._f("pgettext")("Notes", "Register"),
                                labelAlign: _vm.labelAlign
                              }
                            },
                            [
                              _c("ItpFormTextarea", {
                                attrs: { name: "notes" },
                                model: {
                                  value: _vm.editor.notes,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "notes", $$v)
                                  },
                                  expression: "editor.notes"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            { attrs: { labelColsMd: "3", contentColsMd: "9" } },
                            [
                              _c("ItpButton", {
                                attrs: {
                                  type: "submit",
                                  text: _vm.item.isNew
                                    ? _vm.messages.submitNewItem
                                    : _vm.messages.saveItem,
                                  form: _vm.formId,
                                  spinning: _vm.actions.save.isRunning
                                }
                              }),
                              _vm._v(" "),
                              !_vm.item.isNew
                                ? _c("ItpButton", {
                                    attrs: {
                                      text: _vm._f("pgettext")(
                                        "Delete",
                                        "Register"
                                      ),
                                      variant: "danger"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        return _vm.evh_655921014111650_clickPreventStop(
                                          $event,
                                          {}
                                        )
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("ItpButton", {
                                attrs: {
                                  text: _vm._f("pgettext")(
                                    "Cancel",
                                    "Register"
                                  ),
                                  variant: "default"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.evh_1238468668488283_clickPreventStop(
                                      $event,
                                      {}
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("HR"),
              _vm._v(" "),
              !_vm.item.isNew
                ? _c("UcRegisterVersions", {
                    attrs: { register: _vm.item, reload: _vm.lastLoaded },
                    on: {
                      reload: function($event) {
                        return _vm.evh_1889980785424776_reload($event, {})
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }